import { ArrowLeft } from "lucide-react";
import Gallery from "@/components/Gallery";

export default function GalleryPage() {
  return (
    <div data-testid="gallery-page" className="min-h-screen bg-[#FAF8F5]">
      <header className="sticky top-0 z-40 border-b border-stone-200 bg-[#FAF8F5]/90 px-4 py-4 backdrop-blur">
        <a
          data-testid="gallery-back"
          href="/"
          className="mx-auto flex max-w-5xl items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-stone-500 transition-colors hover:text-[#C5A059]"
        >
          <ArrowLeft className="h-4 w-4" /> Retour au mémorial
        </a>
      </header>
      <Gallery full />
    </div>
  );
}
